import { render, staticRenderFns } from "./OrderPie.vue?vue&type=template&id=65cd5328&"
import script from "./OrderPie.vue?vue&type=script&lang=js&"
export * from "./OrderPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports